/**
 * Enum of rules used by the editors to enforce validation.
 */
export enum Rule {
  DuplicateString = 'duplicate-string',
  MaxFileSize = 'max-file-size',
  Required = 'value-required',
  ValidActivationCode = 'valid-activation-code',
  ValidDate = 'valid-date',
  ValidEmail = 'email',
  ValidNumber = 'valid-number',
  ValidFutureTime = 'valid-future-time'
}
